<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <div class="c-widget--info c-widget--info--white" *ngIf="!isLoading" [ngClass]="customClass">
    <ul>
      <li class="title" i18n="@@common.basic_information">Basic Information</li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.name">Name</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.name"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.advertisers">Advertisers</span>: </span>
          <span class="value">
            <p500-ui-many-items
              [data]="data?.advertisers"
              i18n-title="@@advertisers.all"
              title="All Advertisers"
              [tmpl]="tmpl"
            ></p500-ui-many-items>

            <ng-template let-data="data" #tmpl>
              <gtd-ui-field-default-link
                class="font-body-4"
                [link]="['/app/advertisers/advertisers', data?.id]"
                [displayData]="data?.name"
                [relationData]="data?.id"
                [rbacProperty]="RbacPermissionsConstant.WIDGETS_ADVERTISER_PROFILE"
              >
              </gtd-ui-field-default-link>
            </ng-template>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.timestamps">Timestamps</li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.created_at">Created At</span>: </span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.created_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.updated_at">Updated At</span>: </span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.updated_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
    </ul>
  </div>
</gtd-widgets-info-layout>
